import { useEffect, useState } from "react";
import { InputV2 } from "../../../../FormControlsV2";
import { MessageBalloon } from "../../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../../assets/svg/icons/point.svg";
import { ReactComponent as GrassIcon } from "../../../../../assets/svg/icons/grass.svg";

interface InfoCollectRateProps {
  task: ITaskCollect | undefined;
}

export default function InfoCollectRate(task: InfoCollectRateProps) {
  const [taskCollect, setTaskCollect] = useState<ITaskCollect>();
  useEffect(() => {
    setTaskCollect(task.task)
  }, []);

  return (
    <>
      <div>
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskCollect?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`Informar a nota do pasto`} pointed />
      </div>

      {taskCollect?.monitor_value &&
        <div className="containerQuestion">
          <h5>Nota</h5>
          <InputV2 name="info-collect-rate" type="text" value={String(taskCollect?.monitor_value ?? "")} disabled />
        </div>
      }
    </>
  )
}